const resources = {
    forYou: 'Pour vous'
};

export default function getResource(label) {
    return resources[label];
}
